import { render } from "./ProfileChoose.vue?vue&type=template&id=adcefc02&scoped=true"
import script from "./ProfileChoose.vue?vue&type=script&lang=js"
export * from "./ProfileChoose.vue?vue&type=script&lang=js"

import "./ProfileChoose.vue?vue&type=style&index=0&id=adcefc02&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adcefc02"]])

export default __exports__